import { FC, useContext } from 'react';

import { PageContext } from '@rikstv/play-common/src/components/pages/PageContext';
import config from '@rikstv/play-common/src/config';
import { Link } from '@rikstv/play-common/src/router/Link';
import { useRemoteFeatureFlagWithDefault } from '@rikstv/play-common/src/utils/featureFlags/useRemoteFeatureFlag';

import styles from './EditSwimlaneInDeskingLink.module.css';

export const EditSwimlaneInDeskingLink: FC<{ swimlaneId: string; swimlaneName?: string }> = ({
  swimlaneId,
  swimlaneName,
}) => {
  const isEnabled = useRemoteFeatureFlagWithDefault('enable-deskers-tools', false);
  const pageId = useContext(PageContext)?.pageId;

  if (!isEnabled || !pageId) {
    return null;
  }

  return (
    <Link
      className={styles.editSwimlaneInDeskingLink}
      withDefaultStyle={false}
      to={`${config.deskingUrl}/page/${pageId}/swimlane/${swimlaneId}`}>
      Rediger i desking
      {swimlaneName && <span className="sr-only">: {swimlaneName}</span>}
    </Link>
  );
};
